module.exports = __webpack_public_path__ + "media/images/posts/wedding_planning_tasks3-99a30adaef7ec9087340a2b6e935c04a.png";